module.exports = __webpack_public_path__ + "static/media/Huis-2-maps.e97a6d15.jpg";